import {LocalAddress} from '../../models';
import {makeActionCreator} from '../../redux-toolbelt';

export const setLocalAddress = makeActionCreator<'setLocalAddress', LocalAddress | null>('setLocalAddress');
